import { Table } from 'antd';
import * as React from 'react';
import PaginationTable from '../../../../../components/pagination/Pagination';
import useDashboardDetail from '../../../../../hooks/useDashboardDetail';
import { formatMoney, isEmpty } from '../../../../../utils/helpers/helpers';
import './LeftDashboard.scss';

const LeftDashboard = (props) => {
  const {
    onChangePagination,
    handleSortDate,
    sortBy,
    listIncomeStaticDetails,
    totalElements,
    incomeStatic,
    params,
  } = useDashboardDetail({ ...props });
  const columns = [
    {
      title: 'Ngày',
      dataIndex: 'bookingTime',
      key: 'bookingTime',
      render: (bookingTime) => {
        return bookingTime.split(' ')[1].replaceAll('-', '/');
      },
      width: '100px',
    },
    {
      title: 'Sản phẩm',
      dataIndex: 'module',
      key: 'module',
      width: '200px',
    },
    {
      title: 'Giá trị đơn hàng',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      width: '200px',
      render: (totalAmount) => <>{`${formatMoney(totalAmount)} VNĐ`}</>,
    },
    {
      title: 'Trạng thái đơn hàng',
      dataIndex: 'status',
      key: 'status',
      width: '200px',
    },
    {
      title: 'Hoa hồng',
      dataIndex: 'commission',
      key: 'commission',
      width: '200px',
      render: (commission) => <>{`${formatMoney(commission)} VNĐ`}</>,
    },
    {
      title: 'Thời gian hoàn tất',
      dataIndex: 'completedTime',
      key: 'completedTime',
      width: '200px',
    },
  ];
  return (
    <div className='container-dashboard-detail-mobile'>
      <div className='header'>
        <div
          className={`header-sort ${sortBy === 7 ? 'header-sort-7day' : ''} `}
          onClick={() => {
            handleSortDate(7);
          }}
        >
          7 ngày trước
        </div>
        <div
          className={`header-sort ${sortBy === 30 ? 'header-sort-30day' : ''} `}
          onClick={() => {
            handleSortDate(30);
          }}
        >
          30 ngày trước
        </div>
        <div
          className={`header-sort ${sortBy === 90 ? 'header-sort-90day' : ''} `}
          onClick={() => {
            handleSortDate(90);
          }}
        >
          90 ngày trước
        </div>
      </div>
      <div className='content-body'>
        <div className='content'>
          <div className='title'>Tổng doanh số</div>
          <div>
            <div className='count'>
              {`${formatMoney(incomeStatic.revenue || 0)}`}
            </div>
            <div className='currency'>VNĐ</div>
          </div>
        </div>
        <div className='content'>
          <div className='title'>Đơn hàng đã đặt</div>
          <div>
            <div className='count'>{`${formatMoney(
              incomeStatic.gmv || 0
            )}`}</div>
            <div className='currency'>VNĐ</div>
          </div>
        </div>
        <div className='content'>
          <div className='title'>Đơn hàng đã hoàn tiền</div>
          <div>
            <div className='count'>{`${formatMoney(
              incomeStatic.refundAmount || 0
            )}`}</div>
            <div className='currency'>VNĐ</div>
          </div>
        </div>
      </div>
      <div className='data-month'>
        {sortBy === 7
          ? 'Dữ liệu theo tuần'
          : sortBy === 30
          ? 'Dữ liệu theo tháng'
          : 'Dữ liệu theo quý'}
      </div>
      <div className='content-table'>
        <Table
          columns={columns}
          dataSource={listIncomeStaticDetails}
          pagination={false}
        />
      </div>{' '}
      {!isEmpty(listIncomeStaticDetails) && totalElements > 0 && (
        <PaginationTable
          page={params.pageNum}
          size={params.pageSize}
          onChange={onChangePagination}
          totalElements={totalElements}
        />
      )}
    </div>
  );
};

export default LeftDashboard;
